module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cumpleanos"
  }, [_vm._m(0), (_vm.lista.length) ? _c('div', {
    staticClass: "contenedor-scroll"
  }, _vm._l((_vm.lista), function(o) {
    return _c('div', {
      key: o.codigo,
      staticClass: "empleado"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": o.pathFoto
      },
      on: {
        "error": _vm.imagenDefault
      }
    })]), _c('div', {
      staticClass: "datos"
    }, [_c('div', {
      staticClass: "nombre"
    }, [_c('strong', [_vm._v(_vm._s(o.nombre))])]), _c('div', {
      staticClass: "cargo"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("customDate")(o.fechaNacimiento)))])]), _c('div', {
      staticClass: "area"
    }, [_c('span', [_vm._v(_vm._s(o.nombreArea))])])])])
  }), 0) : _c('div', {
    staticClass: "sin-datos"
  }, [_c('span', [_vm._v("No hay cumpleaños hoy 🎈")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo"
  }, [_c('span', [_vm._v("🎂 Cumpleaños de hoy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54330afe","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/c_kpi_cumpleanos.vue
// module id = 881
// module chunks = 0